import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'services/baseQueryWithAuth';

export interface GetImpactScoreEligibilityArgs {
  recipient_id: string;
}

export interface GetImpactScoreEligibilityResponse {
  impact_score: number | null;
  is_eligible: boolean;
  ref_code: string | null;
  badge_url: string | null;
  badge_year: string;
}

export const impactScoreEligibilityApi = createApi({
  reducerPath: 'impactScoreEligibilityApi',
  tagTypes: ['ImpactScoreEligibility'],
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getImpactScoreEligibility: builder.query<
      GetImpactScoreEligibilityResponse,
      GetImpactScoreEligibilityArgs
    >({
      query: ({ recipient_id }) => ({
        url: `/admin/recipients/${recipient_id}/impact-score-eligibility`,
        method: 'GET',
      }),
      providesTags: (result, error, { recipient_id }) => [
        { type: 'ImpactScoreEligibility', id: recipient_id },
      ],
    }),
  }),
});

export const { useGetImpactScoreEligibilityQuery, useLazyGetImpactScoreEligibilityQuery } =
  impactScoreEligibilityApi;
